module.exports = __webpack_public_path__ + "2ed04323448819140fd13ba316fbc631.svg";